import { render, staticRenderFns } from "./TitleDate.vue?vue&type=template&id=d528612c&lang=pug&"
import script from "./TitleDate.vue?vue&type=script&lang=js&"
export * from "./TitleDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports